/**
 * A mixin used primarily for loading data over Ajax and marking it as ready
 */
export default {
  data () {
    return {
      /**
       * This field determines if data has been retrieved from /search service
       * It is used to hide the search form before all data is available
       */
      dataReady: false,
    }
  },

  methods: {
    markDataAsReady () {
      this.dataReady = true
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/DataReadyMixin.js